import React from 'react';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

interface MileageBasedPolicyRouterProps {
	mileageBasedComponent: React.ReactNode;
	standardComponent: React.ReactNode;
}

const MileageBasedPolicyRouter: React.FC<MileageBasedPolicyRouterProps> = ({
	mileageBasedComponent,
	standardComponent,
}) => {
	const policy = useAppSelector((state) => state.fullPolicy);
	const { policyExists: isTrevEnabledPolicy } = useAppSelector((state) => state.telematicsEnabledPolicy);

	// Check if policy is mileage-based (you may need to adjust this condition)
	const isMileageBasedPolicy = policy?.isMileageBasedPolicy || isTrevEnabledPolicy;

	if (isMileageBasedPolicy) {
		return <>{mileageBasedComponent}</>;
	}

	return <>{standardComponent}</>;
};

export default MileageBasedPolicyRouter;
